import { ValueOfObjectFields } from "shared/lib/interfaces/utils";

import { PerformanceCardI } from "./interface";
import PerformanceCardV1 from "./variations/v1";
import PerformanceCardV2 from "./variations/v2";

export const PERFORMANCE_CARD_TYPES = {
  DEFAULT: "default",
  V1: "v1",
  V2: "v2",
} as const;

type PerformanceCardProps = PerformanceCardI & {
  type?: ValueOfObjectFields<typeof PERFORMANCE_CARD_TYPES>;
};

const PerformanceCard = ({ type, ...props }: PerformanceCardProps) => {
  const { DEFAULT, V1, V2 } = PERFORMANCE_CARD_TYPES;

  if (!type || [DEFAULT as string, V1].includes(type)) {
    return <PerformanceCardV1 {...props} />;
  }

  if (V2 === type) {
    return <PerformanceCardV2 {...props} />;
  }

  return null;
};

export default PerformanceCard;
